
<div class="order_quantity_cont">
	<!-- <p>{{itemInStockLeft}}</p> -->
	<ng-container *ngIf="totalQuantity &&  totalQuantity>0">
		<div class="choose-quantity_heading">Choose Quantity</div>
		<div fxLayout class="qty-btn-wrapper">

			<div class="counter">
				<div (click)="minusClicked()" class="btn btn-minus">-</div>
				<div class="order-count">
					<!-- {{quantity}} -->
					<input class="orderInp" type="number" [value]="quantity" (change)="quantityNumber($event)" min="0" id="quantity_input">
				</div>
				<div (click)="plusClicked()" class="btn btn-plus">+</div>
			</div>
			<div class="stock-left-wrapper" *ngIf="!isPreOrderActive">

				<div class="stock_has green-stock-left {{totalQuantity<5?'red':''}}"><span></span></div>

				{{totalQuantity}} {{unit.toLowerCase()}}{{totalQuantity>1?'s':''}} left in stock!

			</div>

			<div class="stock-left-wrapper for_preorder" *ngIf="isPreOrderActive">
				{{unit}} | Minimum Order {{minimumOrderQuantity}} {{unit | lowercase}}{{minimumOrderQuantity>1?'s':''}}
			</div>
		</div>
		<p class="order_text red" *ngIf="orderQuantityExceeded && totalQuantity">
			You can order upto {{totalQuantity}} {{unit.toLowerCase()}}(s) | For more units, Kindly Preorder.
		</p>

		<p class="madeToOrderExceedMessage" *ngIf="madeToOrderExceedMessage">
			Minimum Order {{minimumOrderQuantity}} {{unit | lowercase}} | Kindly PreOrder
		</p>
		<p class="order_text red" *ngIf="orderQuantityExceeded && !totalQuantity">
			Item out of stock | For more units, Kindly Preorder.
		</p>

		<p class="order_text red" *ngIf="isUserTryToDecreaseQuantityThanMOQ">
			Minimum Order  {{minimumOrderQuantity}} {{unit | lowercase}}
		</p>

	</ng-container>

	<ng-container *ngIf="!totalQuantity ||  totalQuantity<0">
		<div class="item_out_of_stock">
			<span class="material-symbols-outlined">
				priority_high
			</span>
			<p>Out of stock</p>
		</div>
		<p class="text-[#ee5416] text-sm">You can <strong class="font-bold text-base">Pre-Order</strong> or Click the <strong class="font-bold text-base">'Notify me'</strong> to get notified once it's back in stock.</p>

	</ng-container>

</div>
